import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Stack } from '@mui/material';
import type { SettingsPanelProps } from '../card';
import {
  allowedFormatsOf,
  FILE_FORMAT_LABELS,
  FILE_FORMATS,
  type AttachmentSettings,
  type FileFormat,
} from 'framework/files';

export const AttachmentSettingsPanel = ({ settings, onChange }: SettingsPanelProps<AttachmentSettings>) => {
  const formats = allowedFormatsOf(settings);
  const toggle = (format: FileFormat) => {
    const next = formats.includes(format) ? formats.filter(other => other !== format) : [...formats, format];
    onChange({ allowedFormats: next.length > 0 ? FILE_FORMATS.filter(each => next.includes(each)) : undefined });
  };
  return (
    <Stack useFlexGap spacing={2}>
      <FormControl component="fieldset" variant="standard">
        <FormLabel component="legend">Allowed formats</FormLabel>
        <FormGroup row>
          {FILE_FORMATS.map(format => {
            const label = FILE_FORMAT_LABELS[format].join(', ');
            return (
              <FormControlLabel
                key={format}
                control={<Checkbox checked={formats.includes(format)} onChange={() => toggle(format)} />}
                label={format === 'image' ? `Images (${label})` : label}
              />
            );
          })}
        </FormGroup>
        <FormHelperText>None ticked: any file can be attached.</FormHelperText>
      </FormControl>
    </Stack>
  );
};
